import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../Routes/ErrorPage";
import Layout from "../Routes/Layout";
import Inicio from "../Routes/Inicio";
import Modelos from "../Routes/Modelos";
import Promociones from "../Routes/Promociones";
import Cookies from "../Routes/Cookies";
import Contacto from "../Routes/Contacto";
import ConcesionariosVenta from "../Routes/ConcesionariosVenta";
import ConcesionariosPostVenta from "../Routes/ConcesionariosPostVenta";
import CotizarService from "../Routes/CotizarService";
import CotizaTuService from "../Components/CotizarService/Sections/CotizaTuService";
import PromiseToCare from "../Components/CotizarService/Sections/PromiseToCare";
import Garantia from "../Components/CotizarService/Sections/Garantia";
import Originales from "../Components/CotizarService/Sections/Originales";
import Asistencia from "../Components/CotizarService/Sections/Asistencia";
import Precios from "../Routes/Precios";
import Subscribirse from "../Routes/Subscribirse";
import TestDrive from "../Routes/TestDrive";
import TyC from "../Routes/TyC";
import PatrocinadorFifa from "../Routes/PatrocinadorFifa";


export const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <ErrorPage />,
    path: "/",
    children: [
      {
        path: "",
        element: <Inicio />,
      },
      // OJO: el .htaccess raiz del servidor no tiene catch-all SPA; cada ruta
      // se habilita a mano alli. Agregar una ruta nueva aca NO alcanza.
      {
        path: ":modelID",
        element: <Modelos />,
      },
      {
        path: "/promociones",
        element: <Promociones />,
      },
      {
        path: "/politica-de-cookies",
        element: <Cookies />,
      },
      {
        path: "/contacto",
        element: <Contacto />,
      },
      {
        path: "/red-venta",
        element: <ConcesionariosVenta />,
      },
      {
        path: "/red-postventa",
        element: <ConcesionariosPostVenta />,
      },
      {
        path: "/precios",
        element: <Precios />,
      },
      {
        path: "/terminos-y-condiciones",
        element: <TyC />,
      },
      {
        path: "/cotizar-service/",
        element: <CotizarService />,
        children: [
          {
            path: "",
            element: <CotizaTuService />,
          },
          {
            path: "promise",
            element: <PromiseToCare />,
          },
          {
            path: "garantia",
            element: <Garantia />,
          },
          {
            path: "originales",
            element: <Originales />,
          },
          {
            path: "asistencia",
            element: <Asistencia />,
          },
        ],
      },
      {
        path: "/subscribirse",
        element: <Subscribirse />,
      },
      {
        path: "/test-drive",
        element: <TestDrive />,
      },
      {
        path: "/patrocinador-oficial-fifa",
        element: <PatrocinadorFifa />,
      },
    ],
  },
]);
